<template>
  <div class="panel shadow">
    <h3 class="panel-title">{{ title }}</h3>
    <div class="panel-content">
      {{ subtitle }}

      <div class="buttons">
        <div class="button-group">
          <a class="button" @click="doLock()" v-show="itemsToLock.length">
            <i class="material-icons">lock</i><span class="label"> Lock</span>
            <span class="number">({{ itemsToLock.length }})</span>
          </a>
          <a class="button info" v-show="itemsToLock.length" @click.stop="previewItems=itemsToLock">
            <i class="material-icons">details</i>
          </a>
        </div>
        <div class="button-group">
          <a class="button" @click="doUnlock(itemsToUnlock)" v-show="itemsToUnlock.length">
            <i class="material-icons">lock_open</i><span class="label"> Unlock</span>
            <span class="number">({{ itemsToUnlock.length }})</span>
          </a>
          <a class="button info" v-show="itemsToUnlock.length" @click.stop="previewItems=itemsToUnlock">
            <i class="material-icons">details</i>
          </a>
        </div>
        <div class="button-group">
          <a class="button" @click="doUnlock(notMatchedItems)" v-show="notMatchedItems.length"
             title="Will unlock all not matching items">
            <i class="material-icons">error</i><span class="label"> Not matching</span>
            <span class="number">({{ notMatchedItems.length }})</span>
          </a>
          <a class="button info" v-show="notMatchedItems.length" @click.stop="previewItems=notMatchedItems">
            <i class="material-icons">details</i>
          </a>
        </div>

      </div>
      <div class="preview" v-if="previewItems.length">
        <i class="material-icons close" @click="previewItems=[]">close</i>
        <item v-for="item in previewItems" :item="item" :key="subtitle+item.key"></item>
      </div>
    </div>
  </div>
</template>

<script>
  import Item from './Item.vue'

  export default {
    name: 'LockPanel',
    props: ['title', 'subtitle', 'items', 'notMatched'],
    data () {
      return {
        previewItems: []
      }
    },
    computed: {
      itemsToLock () {
        return this.items.filter(item => !item.isLocked)
      },
      itemsToUnlock () {
        return this.items.filter(item => item.isLocked)
      },
      notMatchedItems () {
        return this.notMatched.filter(item => item.isLocked)
      }
    },
    methods: {
      doLock () {
        return Promise.all(this.itemsToLock.map(item => this.$store.dispatch('destiny/profile/lockItem', {item})))
      },
      doUnlock (itemsToUnlock) {
        return Promise.all(itemsToUnlock.map(item => this.$store.dispatch('destiny/profile/unLockItem', {item})))
      }
    },
    components: {Item}
  }
</script>

<style lang="scss">
  @import "../styles/settings";
  @import "../styles/panel";

</style>




// WEBPACK FOOTER //
// LockPanel.vue?86d8d2be